import { CheckIcon } from "@xola/icons";
import { Spinner, Tooltip } from "@xola/ui-kit";
import clsx from "clsx";
import React, { ReactNode } from "react";

interface MenuProps {
    children: ReactNode;
    className?: string;
}

export const Menu = ({ children, className }: MenuProps) => {
    return (
        <div className={clsx("ui-menu", "divide-y divide-gray-light overflow-hidden rounded-lg", className)}>
            {children}
        </div>
    );
};

interface MenuItemProps {
    icon: ReactNode;
    children: ReactNode;
    isDisabled?: boolean;
    isLoading?: boolean;
    isSuccess?: boolean;
    tooltip?: string | null;
    onClick?: (e: any) => void;
    className?: string;
}

// TODO: It's similar to ui-kit's `PopoverList.Item`. See how we can merge these two.
const MenuItem = ({
    children,
    icon,
    onClick,
    isDisabled = false,
    isLoading = false,
    isSuccess = false,
    tooltip = null,
    className,
}: MenuItemProps) => {
    const handleClick = (e: any) => {
        if (isDisabled) {
            e.preventDefault();
            e.stopPropagation();
        } else if (onClick) {
            onClick(e);
        }
    };

    return (
        <div
            role="button"
            aria-disabled={isDisabled}
            className={clsx(
                "ui-menu-item",
                "flex w-full items-center space-x-2.5 p-4 font-semibold leading-4 tracking-tightest hover:bg-gray-lighter",
                isDisabled ? "cursor-default text-gray-dark" : "cursor-pointer",
                className,
            )}
            data-testid="menu-button"
            onClick={handleClick}
        >
            {isLoading ? (
                <Spinner data-testid="spinner-icon" size="tiny" />
            ) : isSuccess ? (
                <CheckIcon data-testid="check-icon" />
            ) : (
                icon
            )}

            <span className="flex w-full justify-between">
                {tooltip ? <Tooltip content={tooltip}>{children}</Tooltip> : children}
            </span>
        </div>
    );
};

Menu.Item = MenuItem;
